import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";

type ConfirmArchiveModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isArchiving: boolean;
};

export const ConfirmArchiveModal = ({
  isOpen,
  onClose,
  onConfirm,
  isArchiving,
}: ConfirmArchiveModalProps) => (
  <ModalV2
    show={isOpen}
    onHide={onClose}
    title=""
    size="small"
    data-testid="confirm-archive-modal"
  >
    <ModalV2.Body>
      <Flex flexDirection="column" alignItems="center" gap={SPACING.MEDIUM}>
        <Icon
          type="exclamation-triangle"
          size="xx-large"
          color={Colors.Neutral400}
          variant="outline"
        />
        <Text variant="strong-xl">Archive data package</Text>
        <Text variant="secondary-md" align="center">
          This data package will no longer be available for template creation.
        </Text>
      </Flex>
    </ModalV2.Body>
    <ModalV2.Footer>
      <Flex flexDirection="column" gap={SPACING.SMALL}>
        <Button
          variant="danger"
          onClick={onConfirm}
          isLoading={isArchiving}
          disabled={isArchiving}
          isFullWidth
          data-testid="confirm-archive-button"
        >
          Archive
        </Button>
        <Button variant="neutral" onClick={onClose} disabled={isArchiving} isFullWidth>
          Cancel
        </Button>
      </Flex>
    </ModalV2.Footer>
  </ModalV2>
);
